import React from 'react';
import {
  Text,
  Conditional,
  Space,
  InputField,
  Button,
  Dropdown,
} from '@cashfree-intl/coherent';
import CustomIcons from 'components/CustomIcons';
import CustomIcon from 'components/CustomIcons/main';
import FormikComponent from 'components/Formik';
import { StyledInputVersion, StyledInputWrapper } from '../styled';
import {
  EDIT,
  ERROR,
  PAYMENTS_WEBHOOK_VERSION_DATA,
  SUCCESS,
  TEST,
  TRANSACTION_WEBHOOK_VERSION_DATA,
} from '../constants';
import { validationSchema } from '../helpers';

const EndpointDetails = ({
  actionsMode,
  testStatus,
  loading,
  onTestClickHandler,
  initialValues,
  setEndpointDetails,
  handleEndpointHandling,
  isEndpointChanging,
}) => {
  return (
    <>
      <Text variant="h16" strong>
        Endpoint Details
      </Text>
      <Text color="bodyLight" className="mt-1 mb-3">
        Add endpoint details to receive webhooks.
      </Text>
      <Conditional
        if={testStatus === ERROR && actionsMode === TEST && !isEndpointChanging}
      >
        <Space className="alert-info-space py-1 mb-1">
          <div>
            <CustomIcons
              width="18"
              className="info"
              componentName="ALERT_INFO"
            />
          </div>
          <Text variant="p14" className="ml-2" color="warning">
            The endpoint did not respond properly to the test
          </Text>
        </Space>
      </Conditional>
      <Conditional
        if={
          testStatus === SUCCESS && actionsMode === TEST && !isEndpointChanging
        }
      >
        <Space className="success-info-space py-1 mb-1">
          <div>
            <CustomIcon componentName="GREEN_TICK" />
          </div>
          <Text variant="p14" className="ml-2" color="success">
            The endpoint successfully returned a response
          </Text>
        </Space>
      </Conditional>
      <Conditional
        if={testStatus === ERROR && !actionsMode && !isEndpointChanging}
      >
        <Space className="alert-info-space py-1 mb-1">
          <div>
            <CustomIcon
              width="18"
              className="info"
              componentName="ALERT_INFO"
            />
          </div>
          <Text variant="p14" className="ml-2" color="warning">
            The endpoint did not respond properly to the test, you can still
            select and add events to the endpoint anyway by clicking continue
          </Text>
        </Space>
      </Conditional>
      <Conditional
        if={testStatus === SUCCESS && !actionsMode && !isEndpointChanging}
      >
        <Space className="success-info-space py-1 mb-1">
          <div>
            <CustomIcon componentName="GREEN_TICK" />
          </div>
          <Text variant="p14" className="ml-2" color="success">
            The endpoint successfully returned a response, click continue to
            select events for this endpoint
          </Text>
        </Space>
      </Conditional>
      <div className="modal-content">
        <FormikComponent
          initialValues={initialValues}
          enableReinitialize={true}
          validationSchema={!actionsMode ? validationSchema : null}
        >
          {({
            values = {},
            handleFieldBlur,
            handleFieldChange,
            handleSubmit,
            errors,
            touched,
            setFieldValue,
            setFieldTouched,
            ...formikProps
          }: any) => {
            const disabledField =
              !formikProps.isValidating && formikProps.isSubmitting;
            return (
              <form autoComplete="off">
                <Text color="bodyLight" className="mb-1">
                  Endpoint URL
                </Text>
                <StyledInputWrapper>
                  <InputField
                    className="url-input"
                    id="channelValue"
                    name="channelValue"
                    value={values.channelValue}
                    errors={errors}
                    touched={touched}
                    placeholder="Enter Webhook Endpoint URL"
                    onChange={(e, data) => {
                      handleEndpointHandling(true);
                      handleFieldChange(e, data);
                      setFieldTouched('channelValue', true, false);
                    }}
                    onBlur={handleFieldBlur}
                    loading={loading}
                    disabled={disabledField || actionsMode}
                    fluid
                  />
                  <Button
                    type="button"
                    secondary
                    onClick={() => onTestClickHandler(values.channelValue)}
                    disabled={
                      loading ||
                      actionsMode == EDIT ||
                      !values.channelValue ||
                      errors['channelValue']
                    }
                    data-event-name={`Form_AddTransactionWebhookModal_Endpoint_Button_Test`}
                  >
                    Test
                  </Button>
                </StyledInputWrapper>

                <div className="mt-4" />
                <Text className="mb-1" as="p" color="bodyLight">
                  Select Webhook Version
                </Text>
                <Conditional if={actionsMode !== EDIT && actionsMode !== TEST}>
                  <Dropdown
                    fluid
                    className="versions-dropdown"
                    id="cfApiVersion"
                    name="cfApiVersion"
                    value={values.cfApiVersion}
                    placeholder="Select Version"
                    options={
                      actionsMode
                        ? PAYMENTS_WEBHOOK_VERSION_DATA
                        : TRANSACTION_WEBHOOK_VERSION_DATA
                    }
                    errors={errors}
                    touched={touched}
                    onBlur={handleFieldBlur}
                    onChange={(e, data) => {
                      setEndpointDetails(endpointDetails => ({
                        ...endpointDetails,
                        cfApiVersion: data.value,
                      }));
                      handleFieldChange(e, data);
                    }}
                    icon="chevron down"
                    disabled={actionsMode}
                    selection
                  />
                </Conditional>
                <Conditional if={actionsMode === EDIT || actionsMode === TEST}>
                  <StyledInputVersion
                    id="cfApiVersion"
                    name="cfApiVersion"
                    value={values.cfApiVersion}
                    disabled
                  />
                </Conditional>
              </form>
            );
          }}
        </FormikComponent>
      </div>
    </>
  );
};

export default EndpointDetails;
